<template>
  <div class="image-wrapper">
    <img
      :src="background"
      :class="{ preload: true, show: !show }"
      :alt="`fallback image for ${alt}`"
    />
    <img
      ref="main"
      :src="getImageUrl(src)"
      :class="{ main: true, show: show }"
      @load="showImage"
      :alt="alt"
    />
  </div>
</template>

<script>
import background from '@/assets/svg/placeholder-gray-square.svg'
import getImageSrc from '@/util/getImageSrc'

/**
 * This is used in Instructions
 */
export default {
  name: 'FeatureImage',
  data() {
    return {
      background,
      show: false
    }
  },
  mounted() {
    const img = this.$refs.main
    if (!img || img.complete) {
      this.showImage()
    }
  },
  methods: {
    getImageUrl(url) {
      const fullUrl = `${this.$store.state.exam.base_media_url}/${url}`
      return getImageSrc(fullUrl, this.imageCache)
    },
    showImage() {
      this.show = true
    }
  },
  props: {
    src: {
      type: String,
      default: '',
      required: true
    },
    alt: {
      type: String,
      default: '',
      required: true
    },
    imageCache: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>
.image-wrapper {
  max-width: 12.5rem;
  height: 12.5rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
img {
  width: 12.5rem;
  max-width: 100%;
  height: auto;
}
.preload {
  position: absolute;
  width: 100%;
  height: 100%;
  display: none;
}
.preload.show {
  display: block;
}
.main {
  position: relative;
  visibility: hidden;
}
.show {
  visibility: visible;
}
</style>
